// @flow
import React from 'react';
import classnames from 'classnames';
import ClientConfig from '../context/clientConfig';

const Footer = () => (
  <ClientConfig.Consumer>
    {clientConfig => {
      const {
        footerClassNames, footerComponent, justifyFooter, twitterLink, facebookLink, linkedinLink, youtubeLink, pinterestLink, instagramLink,
      } = clientConfig;
      return (

        <div
          className={classnames(
            `${footerClassNames || ''} client-footer d-flex align-items-center`,
            {
              'justify-content-end': justifyFooter === 'end',
            },
            {
              'justify-content-start': justifyFooter === 'start',
            },
            {
              'justify-content-center': justifyFooter === 'center',
            },
          )}
        >

          {footerComponent}
          <div className='socialMediaIcons'>
            {twitterLink && (
              <a href={twitterLink} target='blank'>
                {' '}
                <i className='fab fa-twitter fa-2x mr-2 twitterIcon' />
              </a>
            )}
            {facebookLink && (
              <a href={facebookLink} target='blank'>
                {' '}
                <i className='fab fa-facebook fa-2x mr-2 facebookIcon' />
              </a>
            )}
            {linkedinLink && (
              <a href={linkedinLink} target='blank'>
                {' '}
                <i className='fab fa-linkedin fa-2x mr-2 linkedinIcon' />
              </a>
            )}
            {youtubeLink && (
              <a href={youtubeLink} target='blank'>
                {' '}
                <i className='fab fa-youtube fa-2x mr-2 youtubeIcon' />
              </a>
            )}
            {pinterestLink && (
              <a href={pinterestLink} target='blank'>
                {' '}
                <i className='fab fa-pinterest fa-2x mr-2 pinterestIcon' />
              </a>
            )}
            {instagramLink && (
              <a href={instagramLink} target='blank'>
                {' '}
                <i className='fab fa-instagram fa-2x mr-2 instagramIcon' />
              </a>
            )}
          </div>
        </div>
      );
    }}
  </ClientConfig.Consumer>
);

export default Footer;
